import inlineLoadingSpinner from '/svg/inline_spinner.svg';
import inlineLoadingSpinnerDark from '/svg/inline_spinner_dark.svg';

export default function InlineLoadingSpinner({type = 'dark', size = 'small'}) {
    return <img src={type === 'light' ? inlineLoadingSpinner : inlineLoadingSpinnerDark}
                alt="loading spinner"
                className={'inline-loading-spinner' + (size === 'large' ? ' inline-loading-spinner--large' : '')}
    />;
}
